import { defineNuxtPlugin } from '#imports'
import VueObserveVisibility from 'vue3-observe-visibility'

export default defineNuxtPlugin({
  name: 'vue-observe-visibility',
  enforce: 'post',
  parallel: true,
  setup(nuxtApp) {
    const { vueApp } = nuxtApp

    vueApp.use(VueObserveVisibility)
  },
})
